import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> { }

const AltArrowLeft: FC<Props> = (props) => {
  // eslint-disable-next-line no-unused-vars
  const { fill, ...customProp } = props;
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...customProp}
      aria-label="alt arrow icon">
      {/* <title>alt arrow icon</title> */}

      <path
        d="M17.5 5.85602L10.5 14.0227L17.5 22.1894"
        stroke={props.fill || "currentColor" || "#3064C0"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AltArrowLeft;
